module.exports.getNBytes = (n, f=16, raw=false) => {
  let out = "";
  let byteArray = crypto.getRandomValues(new Uint8Array(n));
  byteArray.map(b => {
    out+='"0x'+b.toString(f)+'",';
  });
  return '['+out+']';
}
